export const pageVars = {
  ENTITIES: {
    codeText: 'ENTITIES',
    headerText: 'Entities',
    showWarning: true,
    singular: 'entity',
    plural: 'entities'
  },
  ACCOUNTS: {
    codeText: 'ACCOUNTS',
    headerText: 'Accounts',
    showWarning: true,
    singular: 'account',
    plural: 'accounts'
  },
  LOCATIONS: {
    codeText: 'LOCATIONS',
    headerText: 'Locations',
    showWarning: false,
    singular: 'location',
    plural: 'locations'
  },
  USERS: {
    codeText: 'USERS',
    headerText: 'Users',
    showWarning: false,
    singular: 'user',
    plural: 'users'
  },
  PEOPLE: {
    codeText: 'PEOPLE',
    headerText: 'People',
    showWarning: false,
    singular: 'contact',
    plural: 'contacts'
  },
  SERVICES: {
    codeText: 'SERVICES',
    headerText: 'Services',
    showWarning: true,
    singular: 'service',
    plural: 'services'
  },
  SKILLSETS: {
    codeText: 'SKILLSETS',
    headerText: 'Skill Sets',
    showWarning: false,
    singular: 'skill set',
    plural: 'skill sets'
  },
  ACCESS_MANAGEMENT: {
    codeText: 'ACCESS_MANAGEMENT',
    headerText: 'Access Management',
    showWarning: false,
    singular: '',
    plural: ''
  },
  OPERATIONAL_GROUPS: {
    codeText: 'OPERATIONAL_GROUPS',
    headerText: 'Operational Groups',
    showWarning: false,
    singular: '',
    plural: ''
  },
  USER_GROUPS: {
    codeText: 'USER_GROUPS',
    headerText: 'User Groups',
    showWarning: false,
    singular: '',
    plural: ''
  },
  FEATURE_GROUPS: {
    codeText: 'FEATURE_GROUPS',
    headerText: 'Feature Groups'
  },
  TERRITORY_GROUPS: {
    codeText: 'TERRITORY_GROUPS',
    headerText: 'Territory Groups',
    showWarning: false,
    singular: '',
    plural: ''
  },
  COMMERCIAL_ZONES: {
    codeText: 'COMMERCIAL_ZONES',
    headerText: 'Commercial Zones',
    showWarning: false,
    singular: '',
    plural: ''
  },
  GEO_ZONES: {
    codeText: 'GEO_ZONES',
    headerText: 'Geo Zones',
    showWarning: false,
    singular: '',
    plural: ''
  },
  APPROVALS: {
    codeText: 'APPROVALS',
    headerText: 'Approvals',
    showWarning: false,
    singular: '',
    plural: ''
  },
  ALERTS: {
    codeText: 'ALERTS',
    headerText: 'Alerts',
    showWarning: false,
    singular: '',
    plural: ''
  },
  NOTIFICATIONS: {
    codeText: 'NOTIFICATIONS',
    headerText: 'Notifications',
    showWarning: false,
    singular: '',
    plural: ''
  },
  HEATMAPS: {
    codeText: 'HEATMAPS',
    headerText: 'Heatmaps',
    showWarning: false,
    singular: '',
    plural: ''
  },
  USER_ACTIVITY: {
    codeText: 'USER_ACTIVITY',
    headerText: 'User Activity',
    showWarning: false,
    singular: '',
    plural: ''
  },
  AUDIT_LOG: {
    codeText: 'AUDIT_LOG',
    headerText: 'Audit Log',
    showWarning: false,
    singular: '',
    plural: ''
  },
  IMPORT: {
    codeText: 'IMPORT',
    headerText: 'Data Creation',
    showWarning: false,
    singular: '',
    plural: ''
  },
  EXPORT: {
    codeText: 'EXPORT',
    headerText: 'Data Export'
  },
  ADAPTERS_AND_INTEGRATIONS: {
    codeText: 'ADAPTERS_AND_INTEGRATIONS',
    headerText: 'Adapters and Integrations',
    showWarning: false,
    singular: '',
    plural: ''
  },
  THEMES: {
    codeText: 'THEMES',
    headerText: 'Appearance Configuration',
    showWarning: false,
    singular: '',
    plural: ''
  },
  TEMPLATES: {
    codeText: 'TEMPLATES',
    headerText: 'Application Configuration',
    showWarning: false,
    singular: '',
    plural: ''
  },
  MAP_MARKERS: {
    codeText: 'MAP_MARKERS',
    headerText: 'Map Configuration',
    showWarning: false,
    singular: '',
    plural: ''
  },
  DATA_FIELD_MANAGEMENT: {
    codeText: 'DATA_FIELD_MANAGEMENT',
    headerText: 'Data View Configuration',
    showWarning: false,
    singular: '',
    plural: ''
  },
  IMAGE_MANAGEMENT: {
    codeText: 'IMAGE_MANAGEMENT',
    headerText: 'Image Management',
    showWarning: false,
    singular: '',
    plural: ''
  }
}
